const translates = require('@/libs/translates.json') as any

export class Utils {
	locale?: string;

	constructor(locale?: string) {
		this.locale = locale
	}

	Translation = (key: string) => {
		return translates[this.locale || "en-US"][key]
	}
}